import { useState, useEffect } from "react";
import ButtonSwapComp from "./ButtonSwapComp";
import { AnimatePresence } from "framer-motion";
import {
  OtcMarketBody,
  BuySellButton,
  CoinSelectContainer,
  Label,
  OtcLimitWrapper,
  OtcLimitBody,
  OtcChart,
  BoundsContainer,
  BoundItem, StyledNumberFormat,
} from "../../styles/MainOtcStyle";
import Text from "../../utils/Text";
import OtcMiniChart from "./OtcMiniChart";
import {useMainContext} from "../../contexts/main";
import {useAvailableCoin, useMarketQuery} from "../../services/react-query/useMarketQuery";
import {useRunAfterUpdate} from "../../hooks/common/useRunAfterUpdate";
import {onInputValueChangeUtil} from "../../utils/useInputValueChange";
import FilterDropdown from "../../modals/FilterDropdown";
import {stringToNumber, formatNumber, onKeyDown} from "../../utils/common";
import {DText, FlexBetween, FlexCenter, Tooltip} from "../../styles/CommonStyles";
import ModalLayout from "../../layouts/ModalLayout";
import Invoice from "../common/Invoice";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {MOBILE_SIZE} from "../../constants/common";
import {HOME} from "../../constants/urls";
import {useQueryContext} from "../../contexts/query";
import {useProfileQuery} from "../../services/react-query/useProfileQuery";


const ERRORS = {
  en: {max: "Total price is greater than ", min: "Total price is less than "},
  fa: {max: "قیمت انتخابی بیشتر از سقف سفارش گذاری است. سقف سفارش: ", min: "قیمت انتخابی کمتر از کف سفارش گذاری است. کف سفارش: "},

}


const OtcMarketComp = ({activeTab}) => {

  const initialState = {
    buy: {
      amount: "", upper: "", lower: "", price: "", coin: "btc", total: ""
    },
    sell: {
      amount: "", upper: "", lower: "", price: "", coin: "btc", total: ""
    }
  }
  const [otcData, setOtcData] = useState(initialState);

  const [limits, setLimits] = useState({
    min: "", max: ""
  })

  const [networks, setNetworks] = useState()

  const limitErrorInitial = {
    buy: {
      error: false, type: "", value: "", userError: false
    },
    sell: {
      error: false, type: "", value: "", userError: false
    }
  }
  const [limitsError, setLimitsError] = useState(limitErrorInitial)

  const [selectedCoin, setSelectedCoin] = useState(null)
  const [tradeType, setTradeType] = useState("buy");
  const [invoice, setInvoice] = useState(false)

  const { main: {lang}, profile: {token} } = useMainContext()
  const { data: market } = useMarketQuery()
  const {data: available} = useAvailableCoin()
  const {data: profile} = useProfileQuery()
  const { width } = useWindowSize()
  const {setToast} = useQueryContext()


  useEffect(() => {
    if (market) setSelectedCoin(market.find(c => c.id === otcData[tradeType].coin))
  }, [market])


  useEffect(() => {
    if (available) {
      const details = available.find(a => a.id === otcData[tradeType].coin)
      setLimits({max: details?.otc?.max, min: details?.otc?.min})
      setNetworks({
        deposit: details.depositList, withdraw: details.withdrawList
      })
    }
  }, [available, selectedCoin])


  useEffect(() => {
    const amount = stringToNumber(otcData[tradeType].amount)

    let userBalance;
    if (tradeType === "buy") {
      userBalance = profile?.balance / stringToNumber(otcData[tradeType].price)
    }else {
      const userCoin = profile?.coins.find(c => c.coin === otcData[tradeType].coin)
      userBalance = userCoin?.amount
    }

    if (isNaN(amount) || !amount) {
      setLimitsError(
          state => ({
            ...state, [tradeType]: {error: true, type: "amount", value: limits.min, userError: false}
          })
      )
      return
    }

    if (amount > limits.max || amount > userBalance) {
      setLimitsError(
          state => ({
            ...state, [tradeType]: {error: true, type: "max", value: limits.max, userError: amount > userBalance}
          })
      )
    }else if (amount < limits.min) {
      setLimitsError(
          state => ({
            ...state, [tradeType]: {error: true, type: "min", value: limits.min, userError: false}
          })
      )
    }else{
      setLimitsError(limitErrorInitial)
    }
  }, [otcData, tradeType])


  useEffect(() => {
    if (market) {
      setOtcData(initialState)
      setSelectedCoin(market.find(c => c.id === "btc"))
    }
  }, [activeTab])


  const onSwapButtonClicked = () => {
    setTradeType(state => state === "buy" ? "sell" : "buy")
  };


  const createOrder = () => {
    const tradeLimitError = limitsError[tradeType]
    if (!token) {
      window.location.href = HOME + "user/register-signin"
    }else if (tradeLimitError.error && !tradeLimitError.userError) {
      setToast({
        isError: true, show: true,
        message:
            tradeLimitError.type === "amount" ?
                "choose-amount"
                :
                ERRORS[lang][tradeLimitError.type] + formatNumber(limits[tradeLimitError.type])
      })
    }else if (tradeLimitError.userError){
      window.location.href = HOME + "user/wallet-operations"
    }else {
      setInvoice(true)
    }
  }


  const onInvoiceClosed = () => {
    setInvoice(false)
  }

  const runAfterUpdate = useRunAfterUpdate()
  const onAmountChange = (e) => {
    const amount = onInputValueChangeUtil(e, runAfterUpdate)
    let total = 0;
    let price = 0;
    if (selectedCoin) {
      price = selectedCoin[tradeType]
      total = stringToNumber(amount) * price
    }
    setOtcData(state => ({ ...state, [tradeType]: { ...state[tradeType], amount,  total: formatNumber(total), price: formatNumber(price)} }))
  }

  const onTotalPriceChange = (e) => {
    const total = onInputValueChangeUtil(e, runAfterUpdate)
    let amount = 0;
    let price = 0;
    if (selectedCoin) {
      price = selectedCoin[tradeType]
      amount = stringToNumber(total) / price
    }
    setOtcData(state => ({ ...state, [tradeType]: { ...state[tradeType], amount: formatNumber(amount, 6),  total, price: formatNumber(price) }}))
  }

  const onSelectOptionChange = (idx) => {
    setSelectedCoin(market[idx])
    setOtcData(state => ({...state,
      buy: { amount: "", total: "", upper: "", lower: "", coin: market[idx].id },
      sell: { amount: "", total: "", upper: "", lower: "", coin: market[idx].id }
    }))
    setLimitsError(limitErrorInitial)
  }

  const onBoundsChange = (e, type) => {
    const bound = onInputValueChangeUtil(e, runAfterUpdate)
    setOtcData(state => ({...state, [tradeType]: { ...state[tradeType], [type]: bound}}))
  }

  console.log(profile)


  return (
      <>
        <AnimatePresence exitBeforeEnter>
          {activeTab === "market" && (
              <OtcMarketBody
                  initial="in"
                  animate="out"
                  exit="exit"
                  variants={variants}
              >
                <Label typeOnSelect={true}>
                  <Text tid={width < MOBILE_SIZE ? "coin" : "unit"} />
                  <Tooltip right="50px" top="-10px" show={limitsError[tradeType].error && otcData[tradeType].amount}>
                    {limitsError[tradeType].userError ?
                        <Text tid="not-enough-balance" />
                        :
                        `${limitsError[tradeType].type}:${limitsError[tradeType].value}`
                    }
                  </Tooltip>
                </Label>
                <CoinSelectContainer>
                  { /* amount */ }

                  <StyledNumberFormat
                      typeOnSelect={true}
                      value={otcData[tradeType].amount}
                      onChange={onAmountChange}
                      onKeyDown={onKeyDown}
                      placeholder={
                        lang === "us"
                            ? "Please enter an amount"
                            : "لطفا یک مقدار وارد کنید"
                      }
                  />
                  {width < MOBILE_SIZE &&
                      <Label typeOnPro>
                        <Text tid="unit" />
                      </Label>
                  }
                  {market &&
                      <FilterDropdown
                          width={width < MOBILE_SIZE ? "100%" : "70%"}
                          heigth="48px"
                          margin="0"
                          options={market}
                          defaultOption={0}
                          type={tradeType}
                          onOptionChanged={onSelectOptionChange}
                          isCoin
                      />
                  }
                </CoinSelectContainer>

                <Label typeOnSelect={true}>
                  <Text tid="price" />
                </Label>
                <StyledNumberFormat
                    placeholder={lang === "us" ? "Price" : "قیمت"}
                    value={otcData[tradeType].total}
                    onChange={onTotalPriceChange}
                    onKeyDown={onKeyDown}
                />

                <FlexCenter style={{ marginTop: '30px' }}>
                  <FlexBetween width='240px'>
                      <DText>
                        <Text tid='balance' />
                      </DText>
                      <DText style={{ direction: 'ltr' }}>
                        {tradeType === 'buy' ?
                            `${formatNumber(profile?.balance)} IRT`
                            :
                            `${formatNumber(profile?.coins?.find(c => c.coin === selectedCoin?.id)?.amount)} ${selectedCoin?.id?.toUpperCase()}`
                        }
                      </DText>
                  </FlexBetween>
                </FlexCenter>


                <ButtonSwapComp
                    onSwapButtonClicked={onSwapButtonClicked}
                    activeType={tradeType}
                />
                <BuySellButton
                    active={otcData[tradeType].amount && !limitsError[tradeType].error}
                    onClick={createOrder}
                    warning={limitsError[tradeType].userError}
                >
                  <Text tid={
                    !token ? "signin" : (limitsError[tradeType].userError ? "increase-balance" : tradeType)} />
                </BuySellButton>
              </OtcMarketBody>
          )}
        </AnimatePresence>

        <AnimatePresence exitBeforeEnter>
          {activeTab === "limit" && (
              <OtcLimitBody
                  initial="in"
                  animate="out"
                  exit="exit"
                  variants={variants}
              >
                <OtcChart>
                  <OtcMiniChart
                      symbol={
                        otcData[tradeType].coin !== "usdt"
                            ? `KUCOIN:${otcData[tradeType].coin?.toUpperCase()}USDT`
                            : "COINBASE:USDTUSD"
                      }
                  />
                </OtcChart>
                <OtcLimitWrapper>
                  <Label onTypePro>
                    <Text tid="from" />
                  </Label>
                  {market &&
                      <FilterDropdown
                          width="100%"
                          heigth="48px"
                          margin="0"
                          options={market}
                          defaultOption={0}
                          type={tradeType}
                          onOptionChanged={onSelectOptionChange}
                          isCoin
                      />
                  }
                  <Label onTypePro={true}>
                    <Text tid="unit" />
                    <Tooltip right="50px" top="-10px" show={(limitsError[tradeType].error && otcData[tradeType].amount)}>
                      {limitsError[tradeType].userError ?
                          <Text tid="not-enough-balance" />
                          :
                          `${limitsError[tradeType].type}:${limitsError[tradeType].value}`
                      }
                    </Tooltip>
                  </Label>
                  <StyledNumberFormat
                      typeOnPro
                      value={otcData[tradeType].amount}
                      onChange={onAmountChange}
                      onKeyDown={onKeyDown}
                      placeholder={
                        lang === "us"
                            ? "Please enter an amount"
                            : "لطفا یک مقدار وارد کنید"
                      }
                  />

                  <Label onTypePro={true}>
                    <Text tid="price" />
                  </Label>
                  <StyledNumberFormat
                      typeOnPro
                      placeholder={lang === "us" ? "Price" : "قیمت"}
                      value={otcData[tradeType].total}
                      onChange={onTotalPriceChange}
                      onKeyDown={onKeyDown}
                  />

                  <BoundsContainer>
                    <BoundItem>
                      <Label typeOnBound={true} fontSize="12px">
                        <Text tid="upperbound" />
                      </Label>
                      <StyledNumberFormat
                          typeOnPro
                          placeholder={lang === "us" ? "Price" : "قیمت"}
                          value={otcData[tradeType].upper}
                          onChange={(e) => onBoundsChange(e, "upper")}
                          onKeyDown={onKeyDown}
                      />
                    </BoundItem>
                    <BoundItem>
                      <Label typeOnBound={true} fontSize="12px">
                        <Text tid="lowerbound" />
                      </Label>
                      <StyledNumberFormat
                          typeOnPro
                          placeholder={lang === "us" ? "Price" : "قیمت"}
                          value={otcData[tradeType].lower}
                          onChange={(e) => onBoundsChange(e, "lower")}
                          onKeyDown={onKeyDown}
                      />
                    </BoundItem>
                  </BoundsContainer>

                  <FlexCenter>
                    <ButtonSwapComp
                        onSwapButtonClicked={onSwapButtonClicked}
                        activeType={tradeType}
                    />
                  </FlexCenter>
                  <BuySellButton
                      active={otcData[tradeType].amount && !limitsError[tradeType].error}
                      warning={limitsError[tradeType].userError}
                      onClick={createOrder}
                      typeOnPro={true}
                  >
                    <Text tid={
                      !token ? "signin" : (limitsError[tradeType].userError ? "increase-balance" : tradeType)} />
                  </BuySellButton>
                </OtcLimitWrapper>
              </OtcLimitBody>
          )}
          <ModalLayout
              open={invoice}
              onClose={onInvoiceClosed}
              width="90%"
          >
            <Invoice
                data={otcData[tradeType]}
                networks={networks}
                type={tradeType}
                tradeType="otc"
                onClose={onInvoiceClosed}
                otcType={activeTab}
            />
          </ModalLayout>
        </AnimatePresence>
      </>
  );
};

const variants = {
  in: { opacity: 0, transition: { duration: 0.5 } },
  out: { opacity: 1, transition: { duration: 0.5, delay: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.5 } },
};


export default OtcMarketComp;
